import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import AivyLogoRGB from '../assets/images/aivy_logo_rgb.png'
import { Seo } from '../components'
import AuthContainer from '../components/auth-container'
import trackEvents from '../constants/track-events'
import { trackEvent } from '../helpers/analytics'

export default function Login() {
  const { t } = useTranslation()

  return (
    <>
      <Seo title={'Login'} />
      <div className='flex min-h-full flex-1'>
        <div className='flex flex-1 flex-col justify-center py-12'>
          <div className='mx-auto w-full max-w-sm lg:w-96'>
            <div>
              <img className='h-10 w-auto' src={AivyLogoRGB} alt='Aivy GmbH' />
              <h2 className='mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900'>
                {t('authenticator.title_login')}
              </h2>
              <p className='mt-2 text-sm leading-6 text-gray-500'>
                {t('authenticator.no_account')}{' '}
                <Link
                  to='/funnel'
                  className='font-semibold text-blue-600 hover:text-blue-500'
                >
                  {t('authenticator.button_signup')}
                </Link>
              </p>
            </div>
            <div className='mt-10'>
              <AuthContainer context='LOGIN' />
              <p className='mt-4 text-sm leading-6 text-gray-500'>
                {t('authenticator.talent_hint')}{' '}
                <Link
                  to='https://www.aivy.app/talente'
                  onClick={() =>
                    trackEvent(trackEvents.PRESSED_GO_TO_TALENTS)
                  }
                  className='font-semibold text-blue-600 hover:text-blue-500'
                >
                  {t('authenticator.go_here')}
                </Link>
              </p>
            </div>
            <div className='mt-12 flex justify-center gap-x-2 text-sm text-gray-500'>
              <a
                href='https://www.aivy.app/impressum'
                target='_blank'
                rel='noreferrer'
              >
                {t('components.footer.imprint')}
              </a>
              <span>{' | '}</span>
              <a
                href='https://www.aivy.app/datenschutz'
                target='_blank'
                rel='noreferrer'
              >
                {t('components.footer.data_protection')}
              </a>
            </div>
          </div>
        </div>
        <div className='relative hidden w-0 flex-1 lg:block'>
          <img
            className='absolute inset-0 h-full w-full object-cover'
            src='https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80'
            alt=''
          />
        </div>
      </div>
    </>
  )
}
